export enum DeliveryWindowType {
  day = 1,
  week = 2,
  month = 3,
}
